import React from 'react';
import ShopifyData from '../components/shopify-data.js'
import PlanTable from '../components/shopifyPlan.js'
import usePageMeta from '../hooks/usePageMeta';
export default function Ecommerce() {
    usePageMeta('Custom E-Commerce Development Solutions | Spinnennetz', 'Build a high-converting online store with Spinnennetz. We offer tailored e-commerce development services to boost your sales, conversions, and brand loyalty.', '/ecommerce', {"@context":"https://schema.org","@type":"Service","name":"E-Commerce Development","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <>
            <ShopifyData />
            <PlanTable />
        </>
    );
}
